import assign from 'lodash/assign';

export const ScriptLoaderService = angular
    .module('ScriptLoaderService', [])
    .service('scriptLoaderService', ($document, $window, $q) => {
        function loadFacebookPixel(fbPixelId) {
            if (!$window.fbq) {
                loadScriptTag({
                    text: `
                        !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
                        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
                        document,'script','//connect.facebook.net/en_US/fbevents.js');
                        fbq('init', '${fbPixelId}');
                        fbq('track', 'PageView');
                    `
                });
            }
        }

        function loadGTM(gtmId) {
            loadScriptTag({
                text: `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer', '${gtmId}');
                `
            });
        }

        function loadScriptTag(options) {
            const script = $document[0].createElement('script');
            assign(script, options);
            script.type = 'text/javascript';
            if (options.attributes && options.attributes.length > 0) {
                Object.keys(options.attributes).forEach((key) => {
                    script.setAttribute(
                        options.attributes[key].name,
                        options.attributes[key].value
                    );
                });
            }
            $document[0].body.appendChild(script);
        }

        function loadScriptTagPromise(options) {
            const deferred = $q.defer();
            loadScriptTag({
                ...options,
                onload: deferred.resolve,
                onerror: deferred.reject
            });
            return deferred.promise;
        }

        return {
            loadScriptTag,
            loadScriptTagPromise,
            loadFacebookPixel,
            loadGTM
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/scriptLoader.service.js